class LuximinaWelcomePopup extends HTMLElement {
  connectedCallback() {
    this.closeButtons = this.querySelectorAll('[data-welcome-close]');
    this.panel = this.querySelector('[role="dialog"]');
    this.email = this.querySelector('input[type="email"]');
    this.success = this.dataset.success === 'true';
    this.onKeydown = this.onKeydown.bind(this);
    this.close = this.close.bind(this);

    this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
    document.addEventListener('keydown', this.onKeydown);

    if (this.success) {
      localStorage.setItem('luximina-welcome-subscribed', 'true');
      this.open();
      return;
    }

    if (Shopify.designMode) return;
    if (localStorage.getItem('luximina-welcome-subscribed') === 'true') return;

    const dismissedAt = Number(localStorage.getItem('luximina-welcome-dismissed') || 0);
    const oneDay = 24 * 60 * 60 * 1000;
    if (Date.now() - dismissedAt < oneDay) return;

    this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 5000);
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
    this.closeButtons?.forEach((button) => button.removeEventListener('click', this.close));
    document.removeEventListener('keydown', this.onKeydown);
  }

  open() {
    this.previouslyFocused = document.activeElement;
    this.hidden = false;
    document.body.classList.add('lux-welcome-open');
    requestAnimationFrame(() => (this.email || this.panel)?.focus());
  }

  close() {
    this.hidden = true;
    document.body.classList.remove('lux-welcome-open');
    if (!this.success) localStorage.setItem('luximina-welcome-dismissed', String(Date.now()));
    this.previouslyFocused?.focus?.();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && !this.hidden) this.close();
  }
}
if (!customElements.get('luximina-welcome-popup')) {
  customElements.define('luximina-welcome-popup', LuximinaWelcomePopup);
}
